import { render } from "./PopupView.vue?vue&type=template&id=f447b90a&scoped=true"
import script from "./PopupView.vue?vue&type=script&lang=js"
export * from "./PopupView.vue?vue&type=script&lang=js"

import "./PopupView.vue?vue&type=style&index=0&id=f447b90a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f447b90a"]])

export default __exports__